import React, { useState } from 'react';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import Settings from './pages/Settings';

const SIDEBAR_WIDTH = 220;
const TOPBAR_HEIGHT = 60;
const ACCENT = '#ff8c42';
const SIDEBAR_BG = '#1e1e2e';
const SIDEBAR_TEXT = '#cdd6f4';
const SIDEBAR_ACTIVE_BG = '#313244';
const CONTENT_BG = '#f4f5f7';

const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'tasks', label: 'Tasks' },
  { id: 'settings', label: 'About' },
];

const PAGE_TITLES = {
  dashboard: 'Dashboard',
  tasks: 'Tasks',
  settings: 'About',
};

function Sidebar({ currentPage, onNavigate }) {
  return (
    <aside
      style={{
        width: SIDEBAR_WIDTH,
        minHeight: '100vh',
        background: SIDEBAR_BG,
        color: SIDEBAR_TEXT,
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 100,
        flexShrink: 0,
      }}
    >
      {/* Brand */}
      <div
        style={{
          padding: '20px 20px',
          borderBottom: '1px solid #313244',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <span
          style={{
            fontSize: 30,
            fontWeight: 900,
            color: ACCENT,
            letterSpacing: '-1px',
          }}
        >
          HX
        </span>
        <span style={{ fontSize: 13, color: '#7f849c' }}>Cloud App</span>
      </div>

      {/* Nav */}
      <nav style={{ padding: '16px 10px', flex: 1 }}>
        {NAV_ITEMS.map(item => {
          const active = currentPage === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                width: '100%',
                padding: '11px 14px',
                marginBottom: 4,
                borderRadius: 10,
                border: 'none',
                borderLeft: active ? `3px solid ${ACCENT}` : '3px solid transparent',
                background: active ? SIDEBAR_ACTIVE_BG : 'transparent',
                color: active ? '#fff' : SIDEBAR_TEXT,
                fontSize: 15,
                fontWeight: active ? 600 : 400,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'background 0.15s',
              }}
            >
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Sidebar footer */}
      <div
        style={{
          padding: '14px 20px',
          borderTop: '1px solid #313244',
          fontSize: 12,
          color: '#7f849c',
        }}
      >
      </div>
    </aside>
  );
}

function TopBar({ page }) {
  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: SIDEBAR_WIDTH,
        right: 0,
        height: TOPBAR_HEIGHT,
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        padding: '0 28px',
        zIndex: 99,
        boxShadow: '0 1px 8px #0000000d',
      }}
    >
      <h2 style={{ margin: 0, fontSize: 19, fontWeight: 700, color: '#1e1e2e' }}>
        {PAGE_TITLES[page]}
      </h2>
      <div style={{ flex: 1 }} />
      {/* Avatar placeholder */}
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: ACCENT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontWeight: 800,
          fontSize: 15,
          userSelect: 'none',
        }}
      >
        H
      </div>
    </header>
  );
}

export default function App() {
  const [page, setPage] = useState('dashboard');

  const renderPage = () => {
    switch (page) {
      case 'dashboard':
        return <Dashboard onNavigate={setPage} />;
      case 'tasks':
        return <Tasks />;
      case 'settings':
        return <Settings />;
      default:
        return <Dashboard onNavigate={setPage} />;
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        background: CONTENT_BG,
        minHeight: '100vh',
      }}
    >
      <Sidebar currentPage={page} onNavigate={setPage} />
      <TopBar page={page} />
      <main
        style={{
          marginLeft: SIDEBAR_WIDTH,
          paddingTop: TOPBAR_HEIGHT,
          minHeight: '100vh',
          background: CONTENT_BG,
        }}
      >
        <div style={{ padding: '32px 36px' }}>{renderPage()}</div>
      </main>
    </div>
  );
}
